export default [
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
  {
    id: 4535024222281,
    title: "5 O CLOCK CAMP SHIRT - Blue Cove",
    body_html: null,
    vendor: "Tommy Bahama",
    product_type: "",
    created_at: "2020-08-06T04:18:30-04:00",
    handle: "st225202-tb16336",
    updated_at: "2020-08-23T02:00:10-04:00",
    published_at: "2020-08-06T04:18:30-04:00",
    template_suffix: null,
    published_scope: "web",
    tags: "",
    variants: [
      {
        id: 31743566872649,
        product_id: 4535024222281,
        title: "S",
        price: "158.00",
        sku: "243085_745946_3574378",
        position: 1,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "S",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569218",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137735241,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743566938185,
        product_id: 4535024222281,
        title: "M",
        price: "158.00",
        sku: "243085_745946_3574379",
        position: 2,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "M",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569225",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137768009,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567003721,
        product_id: 4535024222281,
        title: "L",
        price: "158.00",
        sku: "243085_745946_3574380",
        position: 3,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "L",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569232",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137800777,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567069257,
        product_id: 4535024222281,
        title: "XL",
        price: "158.00",
        sku: "243085_745946_3574381",
        position: 4,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569249",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137833545,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567134793,
        product_id: 4535024222281,
        title: "2XL",
        price: "158.00",
        sku: "243085_745946_3574376",
        position: 5,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "2XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569256",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137866313,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
      {
        id: 31743567167561,
        product_id: 4535024222281,
        title: "3XL",
        price: "158.00",
        sku: "243085_745946_3574377",
        position: 6,
        inventory_policy: "deny",
        compare_at_price: "158.00",
        fulfillment_service: "manual",
        inventory_management: null,
        option1: "3XL",
        option2: null,
        option3: null,
        created_at: "2020-08-06T04:18:31-04:00",
        updated_at: "2020-08-06T04:18:31-04:00",
        taxable: true,
        barcode: "0755633569263",
        grams: 0,
        image_id: null,
        weight: 0,
        weight_unit: "kg",
        inventory_item_id: 33570137899081,
        inventory_quantity: 0,
        old_inventory_quantity: 0,
        requires_shipping: true,
      },
    ],
    options: [
      {
        id: 5893785026633,
        product_id: 4535024222281,
        name: "Title",
        position: 1,
        values: ["S", "M", "L", "XL", "2XL", "3XL"],
      },
    ],
    images: [
      {
        id: 14460259729481,
        product_id: 4535024222281,
        position: 1,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_bdf23a3c-518e-45da-a86b-73a4b8b55fd6.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259762249,
        product_id: 4535024222281,
        position: 2,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt1_187f705d-d9fe-40da-994f-80aa4bd27120.jpg?v=1598162409",
        variant_ids: [],
      },
      {
        id: 14460259795017,
        product_id: 4535024222281,
        position: 3,
        created_at: "2020-08-23T02:00:09-04:00",
        updated_at: "2020-08-23T02:00:09-04:00",
        alt: null,
        width: 772,
        height: 965,
        src:
          "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_alt2_cc0dbd8b-3878-4e13-82b6-c3ee36bf31c9.jpg?v=1598162409",
        variant_ids: [],
      },
    ],
    image: {
      id: 14460259729481,
      product_id: 4535024222281,
      position: 1,
      created_at: "2020-08-23T02:00:09-04:00",
      updated_at: "2020-08-23T02:00:09-04:00",
      alt: null,
      width: 772,
      height: 965,
      src:
        "https://cdn.shopify.com/s/files/1/0278/5391/4185/products/ST225202_16336_main_1080x.jpg?v=1598180422",
      variant_ids: [],
    },
  },
];